import type { Action, PayloadAction } from "@reduxjs/toolkit";
import * as actions from "./actions";
import type { IPriceMode } from "./models";

function resolveInitialPriceMode(): IPriceMode["priceMode"] {
  const stored = localStorage.getItem("Verwimp.catalog.price-mode");
  if (stored === "retail") return "retail";
  if (stored === "hidden") return "hidden";
  return "customer";
}

const initialState: IPriceMode = {
  priceMode: resolveInitialPriceMode(),
};

export default function priceModeReducer(
  state: IPriceMode,
  action: Action,
): IPriceMode {
  if (typeof state === "undefined") {
    return initialState;
  }
  switch (action.type) {
    case actions.UPDATE: {
      const data = (action as PayloadAction<IPriceMode>).payload;
      return { ...data };
    }
    default:
      return state;
  }
}
